import {useTranslation} from 'react-i18next'
import {HelpIcon} from '@/components/help-icon'
import {PorQue} from '@/components/ui/por-que'
import {MicroLabel} from '@/components/period-selector'
import type {CertificacionArtefacto} from '@/hooks/sgsst/expediente/use-certificacion'

const QUE_QUEDA = ['documento', 'firma', 'estandares', 'vigencia', 'historia'] as const

export function QueEsUnaVersionCertificada({artefacto}: {artefacto: CertificacionArtefacto}) {
  const {t} = useTranslation()
  return (
    <section className="space-y-4" data-testid="certificacion-que-es">
      <p className="text-sm text-foreground">{t('certificacion.queEs.definicion')}</p>

      <div className="grid gap-3 sm:grid-cols-2">
        <div className="rounded-lg border border-border p-3" data-testid="certificacion-que-es-vivo">
          <MicroLabel>{t('certificacion.queEs.vivo.titulo')}</MicroLabel>
          <p className="mt-1.5 text-xs text-muted-foreground">{t(`certificacion.queEs.vivo.${artefacto}`)}</p>
        </div>
        <div
          className="rounded-lg border border-primary/30 bg-accent/50 p-3"
          data-testid="certificacion-que-es-certificada">
          <MicroLabel>{t('certificacion.queEs.certificada.titulo')}</MicroLabel>
          <p className="mt-1.5 text-xs text-foreground">{t('certificacion.queEs.certificada.cuerpo')}</p>
        </div>
      </div>

      {/* Un solo disparador: el porqué y el inventario son la misma respuesta. */}
      <PorQue
        label={t('certificacion.queEs.porQueLabel')}
        testId="certificacion-que-es-porque"
        contenidoTestId="certificacion-que-es-porque-contenido">
        <p>{t('certificacion.queEs.porQue')}</p>
        <p className="font-mono text-[10px] font-medium tracking-wider text-muted-foreground uppercase">
          {t('certificacion.queEs.queQueda.titulo')}
        </p>
        <ul className="space-y-1.5">
          {QUE_QUEDA.map((clave) => (
            <li key={clave} className="flex gap-2">
              <span className="mt-1.5 size-1 shrink-0 rounded-full bg-primary" aria-hidden="true" />
              <span>{t(`certificacion.queEs.queQueda.${clave}`)}</span>
            </li>
          ))}
        </ul>
      </PorQue>
    </section>
  )
}

/** Su segunda frase es la misma cadena del bloque grande para que no diverjan. */
export function ExplicacionCorta() {
  const {t} = useTranslation()
  return (
    <div className="space-y-2">
      <p>{t('certificacion.queEs.help')}</p>
      <p>{t('certificacion.queEs.porQue')}</p>
    </div>
  )
}

export function VersionCongeladaNota({artefacto}: {artefacto: CertificacionArtefacto}) {
  const {t} = useTranslation()
  return (
    <p className="flex items-start gap-1.5 text-xs text-muted-foreground" data-testid="certificacion-congelada-nota">
      <span>{t(`certificacion.queEs.congelada.${artefacto}`)}</span>
      <HelpIcon label={t('certificacion.queEs.eyebrow')} testId="certificacion-que-es-help">
        {<ExplicacionCorta />}
      </HelpIcon>
    </p>
  )
}
